import { request } from "../../../services/api.ts"
import type { MarketingData, MarketingPeriodType } from "../types"

export interface MarketingQuery {
  period: MarketingPeriodType
  anchor: string
  sources: string[]
}

export const fetchMarketingSourcePerformance = ({
  period,
  anchor,
  sources
}: MarketingQuery) =>
  request.api.get<MarketingData>("/dashboard/marketing-source-performance/", {
    period,
    // Empty asks for the period holding today in the user's own timezone.
    ...(anchor ? { anchor } : {}),
    ...(sources.length ? { sources: sources.join(",") } : {})
  })
